import React from "react";
import type {testimonialData as TestimonialData} from "./utils";
import {useCarousel} from "./useCarousel";

type TestimonialProps = {
  testimonialData: typeof TestimonialData;
};

export const Testimonial: React.FC<TestimonialProps> = ({
  testimonialData,
}) => {
  const {carouselRef, shouldAutoplay} = useCarousel(
    testimonialData.length,
    16
  );

  return (
    <div className="bg-white">
      <h4 className="text-center py-8 text-[15px] text-[#535151] md:text-2xl">
        TESTIMONIALS
      </h4>
      <h1 className="text-center text-black text-2xl md:text-4xl">
        That's what our customer say
      </h1>
      <div
        ref={carouselRef}
        className={`w-full flex overflow-x-auto px-4 py-8 scroll-smooth ${
          shouldAutoplay ? "" : "justify-center"
        }`}
      >
        <div className="flex gap-8 min-w-max">
          {testimonialData.map((testimonial, index) => (
            <div
              key={index}
              className="flex-shrink-0 w-[320px] bg-white text-black py-6 md:p-10 rounded-xl  shadow-xl"
            >
              <div className="flex flex-col items-center">
                {Object.entries(testimonial).map(([key, value]) =>
                  typeof value === "string" &&
                  key.toLowerCase().includes("image") ? (
                      <img
                        key={key}
                        src={value}
                        alt={testimonial.name || "testimonial image"}
                        className="w-20 h-20 rounded-full mb-4"
                      />
                    ) : null
                )}

                <div className="text-sm text-center px-4">
                  {testimonial.comment}
                </div>

                <div className="mt-4 text-center">
                  <p className="text-lg font-bold">{testimonial.name}</p>
                  <p className="text-sm">{testimonial.location}</p>
                </div>

                <div className="flex mt-2">
                  {Array.from({length: testimonial.rating || 0}).map(
                    (_, i) => (
                      <span key={i} className="text-yellow-300 text-lg">
                        ★
                      </span>
                    )
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
